import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { useGetPrivileges } from '../../../../api/privilege/privilege';
import { useDefaultOptions } from '../../../../hooks/api';
import * as sessionStorageUtils from '../../../../utils/sessionStorage';
import { PrivilegesDownload } from './PrivilegesDownload';
import PrivilegesList from './PrivilegesList';

/**
 * タブタイトル
 * @returns
 */
function Title() {
  // 言語情報
  const { t } = useTranslation();
  return (
    <Helmet>
      <title>{t('CMS-POC|権限一覧')}</title>
    </Helmet>
  );
}

function IndexPage() {
  // const [openSearchConditions, setOpenSearchConditions] = useState(false);
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const options = useDefaultOptions(language);

  // 一覧取得
  const mastersResponse = useGetPrivileges(options);

  if (mastersResponse.isLoading) {
    return <>{t('お待ちください。')}</>;
  }

  if (mastersResponse.isError || mastersResponse.data.data.privileges_list_items == null) {
    return <>{t('エラーが発生しました。')}</>;
  }

  // ソートの初期条件をセッションに登録（PrivilegesList内ではうまく動かなかった。）
  sessionStorageUtils.set('Privileges.SortInfo', { key: 'sort_order', isDisc: false });

  return (
    <div id="main">
      <Title />
      <section>
        <div className="ttlsep prolist">
          <div className="left">
            <h3 className="trig">
              <span>{t('権限一覧')}</span>
            </h3>
          </div>
          <div className="right">
            <ul>
              <li>
                <PrivilegesDownload />
              </li>
            </ul>
          </div>
        </div>
        <PrivilegesList
          data={mastersResponse.data}
          isLoading={mastersResponse.isLoading}
          isError={mastersResponse.isError}
        />
      </section>
    </div>
  );
}

export default IndexPage;
